import React from "react";
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import HeaderCtas from "../../../common/extras/HeaderCtas";
// import SearchBox from "./SearchBox";

const Header = (props) => {
  const { t } = useTranslation();

  const headerContents = useSelector(
    (state) => state.main.pageContents.LANDING.HEADER
  );

  return (
    <header className="masthead short" style={{
      minHeight: headerContents.ctas.length > 0 ? "33rem" : "28rem"
    }}>
      <div className="container h-100">
        <div className="row h-100 align-items-center justify-content-center text-center">
          <div className="col-lg-10 align-self-end">
            {headerContents.main_header_top ? (
              <p
                className="text-white-75 font-weight-light mb-5"
                style={{
                  minHeight: "30px",
                }}
              >
                {t(headerContents.main_header_top)}
              </p>
            ) : null}

            <h1
              className="text-uppercase text-white font-weight-bold"
              style={{
                minHeight: "50px",
              }}
            >
              <strong>{t(headerContents.main_header_middle_big)}</strong>
            </h1>
            <hr className="divider my-4" />
            {/* <SearchBox /> */}
          </div>
          <div className="col-lg-8 align-self-baseline">
            <p
              className="text-white-75 font-weight-light mb-4"
              style={{
                minHeight: "30px",
              }}
            >
              {t(headerContents.main_header_bottom)}
            </p>
            <HeaderCtas headerCtas={headerContents.ctas} btnGroupClass="" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default withRouter(Header);
